import React from "react";
import "./component-css/LearningMaterials.css";

const SustainableConstruction = () => {
        const materials = [
            {
                title: "Reusing Materials in Construction",
                type: "pdf",
                link: "/materials/sustainable-construction/UKIM_English.pdf",
                description:
                    "Covers the idea of reusing building materials to cut waste and make construction more environmentally friendly."
            },
            {
                title: "Circular Economy in the Built Environment",
                type: "youtube",
                link: "https://youtu.be/lolxiElzHMQ",
                description:
                    "An overview of circular economy principles and their application in the design and management of sustainable built environments."
            },
            {
                title: "Application of UAV Photogrammetry in Post-Disaster Damage Assessment",
                type: "youtube",
                link: "https://youtu.be/106y73-OF8o",
                description:
                    "An overview of how UAV photogrammetry can support rapid and accurate assessment of damage after disasters."
            },
            {
                title: "Sustainable Development and SDGs",
                type: "youtube",
                link: "https://youtu.be/PwY2204UeqI",
                description:
                    "An overview of sustainable development principles and the role of the Sustainable Development Goals (SDGs) in addressing global challenges."
            }
        ];
    return (
        <div className="content-page lm-page">
            <header className="lm-header">
                <h1 className="lm-title">Sustainable Construction Learning Materials</h1>
                <p className="lm-subtitle">
                    Resources and videos on circular building practices, material reuse,
                    and designing a more sustainable built environment.
                </p>
            </header>

            <div className="lm-list">
                {materials.map((m, index) => (
                    <div key={index} className="lm-card">
                        <h3 className="lm-card-title">{m.title}</h3>

                        <p className="lm-card-desc">{m.description}</p>

                        <a
                            href={m.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lm-card-link"
                        >
                            {m.type === "pdf" ? "📄 Open PDF" : "▶ Watch Video"}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SustainableConstruction;
